import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.NumberLineSimpleMissing.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.NumberLineSimpleMissing.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.collectedSprites = [];
  this.questionMark = null;
  this.items = [];
  this.choices = [];
};

// eslint-disable-next-line max-len
EDC.Games.NumberLineSimpleMissing.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.NumberLineSimpleMissing.Scenes.Main.prototype.constructor = EDC.Games.NumberLineSimpleMissing.Scenes.Main;

const NLSM = EDC.Games.NumberLineSimpleMissing.Scenes.Main.prototype;

NLSM.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

NLSM.createTemplateUI = function () {
  const title = this.add.sprite(300, 170, 'title');
  const instructions = this.add.sprite(1050, 180, 'instructions');
};

NLSM.loadIteration = function () {
  this.createLine();
  this.createChoices();
};

NLSM.createLine = function () {
  const bars = [];
  for (let i = 0; i < 9; i++) {
    const bar = this.add.sprite(450 + i * (1130 / 9), 575, 'bar');
    bars.push(bar);
    this.collectedSprites.push(bar);
  }
  const line = this.add.sprite(950, 600, 'line');
  this.collectedSprites.push(line);
  this.addQuestion(bars);
  const { givenItems } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  for (let i = 0; i < givenItems.length; i++) {
    const item = this.add.sprite(0, 0, `asset-${givenItems[i].id}`);
    item.x = bars[givenItems[i].position - 1].x;
    item.y = bars[givenItems[i].position - 1].y - item.displayHeight / 2;
    this.items.push(item);
  }
};

NLSM.addQuestion = function (barsArray) {
  const bars = barsArray;
  const { questionPosition } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const container = this.add.container(bars[questionPosition - 1].x, bars[questionPosition - 1].y);
  const question = this.add.sprite(10, 0, 'question-mark');
  const randomNumber = 1 + Math.floor(Math.random() * 4);
  const planet = this.add.sprite(0, 0, `planet-${randomNumber}`);
  container.y -= question.displayHeight / 2;
  container.add(planet);
  container.add(question);
  this.scaleAnimation(container);
  this.questionMark = container;
};

NLSM.scaleAnimation = function (container) {
  container.scaleAnim = this.tweens.add({
    targets: container,
    scaleX: 1.2,
    scaleY: 1.2,
    duration: 350,
    ease: 'Sine.easeInOut',
    delay: 5500,
    yoyo: true,
    onComplete: this.scaleAnimation.bind(this, container),
  });
};

NLSM.createChoices = function () {
  const { choices } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { correctAnswer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  for (let i = 0; i < choices.length; i++) {
    const container = this.add.container(0, 0);
    const saucer = this.add.sprite(0, 50, 'saucer');
    const number = this.add.sprite(0, -saucer.displayHeight + 50, `asset-${choices[i].id}`);
    container.add(saucer);
    container.add(number);
    container.y = 900;
    container.x = 350 + i * 400;
    container.setSize(saucer.displayWidth, saucer.displayHeight + number.displayHeight);
    if (i === correctAnswer - 1) {
      container.isCorrect = true;
    } else {
      container.isCorrect = false;
    }
    this.floatAnimation(container);
    container.setInteractive();
    const markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.choices.push(container);
  }
};

NLSM.checkAnswer = function (container) {
  if (container.isCorrect) {
    this.playCorrect();
    container.first.setTint(0x0ffff0);
    container.next.setTint(0x0ffff0);
    this.choices.map((x) => {
      x.disableInteractive();
    });
    this.questionMark.scaleAnim.stop();
    container.floatAnim.stop();
    this.startFly(container);
  } else {
    container.first.setTint(0xff0000);
    container.next.setTint(0xff0000);
    container.floatAnim.stop();
    container.disableInteractive();
    this.playWrong();
    container.getData('markAnim').showMark(false, () => {});
  }
};

NLSM.startFly = function (container) {
  this.tweens.add({
    targets: container,
    angle: 3,
    duration: 300,
    ease: 'Sine.easeInOut',
    repeat: 1,
    yoyo: true,
  });
  this.tweens.add({
    targets: container,
    x: this.questionMark.x,
    y: this.questionMark.y + 60,
    duration: 1700,
    ease: 'Sine.easeInOut',
    delay: 300,
    onComplete: this.dropNumber.bind(this, container),
  });
};

NLSM.dropNumber = function (container) {
  container.angle = 0;
  this.questionMark.last.destroy();
  const sprite = container.getAt(1);
  sprite.y += 55;
  sprite.x += 5;
  this.questionMark.add(sprite);
  this.tweens.add({
    targets: container,
    y: -250,
    duration: 2000,
    ease: 'Sine.easeInOut',
    delay: 200,
    completeDelay: 1500,
    onComplete: this.nextIteration.bind(this),
  });
  this.tweens.add({
    targets: container,
    angle: 3,
    duration: 300,
    ease: 'Sine.easeInOut',
    repeat: 3,
    yoyo: true,
  });
};

NLSM.floatAnimation = function (container) {
  const randomDistance = 10 + Math.round(Math.random() * 5);
  const randomDelay = Math.round(Math.random() * 800);
  // const randomTime = 900 + Math.round(Math.random() * 400);
  container.floatAnim = this.tweens.add({
    targets: container,
    y: container.y - randomDistance,
    duration: 1200,
    ease: 'Sine.easeInOut',
    repeat: -1,
    delay: randomDelay,
    yoyo: true,
  });
};

NLSM.nextIteration = function () {
  this.collectedSprites.map((x) => {
    x.destroy();
  });
  this.collectedSprites = [];
  this.questionMark.destroy();
  this.questionMark = null;
  this.items.map((x) => {
    x.destroy();
  });
  this.items = [];
  this.choices.map((x) => {
    x.destroy();
  });
  this.choices = [];
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

export default EDC.Games.NumberLineSimpleMissing.Scenes.Main;
